export default function PHP_get_resource_type() {
  return (
    <div>
      <h1>PHP_get_resource_type</h1>
    </div>
  );
}
